import type { ActivatedDrawId } from '../../../../../schema/marketplace/entry.js';
import { getInstanceClient } from '../../../../di/entry.browser.js';
import type { ActionResult } from '../../../../lib/entry.browser.js';

type RetailerBalanceReturnType = Awaited<
  ReturnType<ReturnType<typeof getInstanceClient<'IGetRetailerBalanceController'>>>
>;

type GetRetailerBalanceParams = {
  activatedDrawId: ActivatedDrawId;
};

/**
 * Function to get retailer balance.
 *
 * @param root0 - The parameters for getting retailer balance
 * @param root0.activatedDrawId - The activated draw ID for which to get the retailer balance
 * @returns The retailer balance info
 */
export async function getRetailerBalance({
  activatedDrawId,
}: GetRetailerBalanceParams): Promise<ActionResult<RetailerBalanceReturnType>> {
  const getRetailerBalanceController = getInstanceClient('IGetRetailerBalanceController');

  try {
    const response = await getRetailerBalanceController({ activatedDrawId });
    return { status: 'SUCCESS', data: response };
  } catch {
    return { status: 'ERROR', error: 'Det gick inte att hämta saldo för tillfället' };
  }
}
